// src/encounter/services/use-medication-masters.ts
// Medication master lists for the A/P dose form (PROD-1340). Ported from the Flutter
// common datasource (common_data_source_impl.dart medicationRoutes()/medicationUnits()):
//   GET /api/Master/MedicationRoute               → Code[]   (administration routes)
//   GET /api/Master/MedicationUnitOfMeasurement   → string[] (dose/dispense units: mg, tablet, ml…)
// Both are small, stable master lists (NOT the giant UCUM table behind the documents'
// GetUnitOfMeasurements typeahead) — so they populate fixed Select dropdowns. Long staleTime.
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { ProviderCode } from '@/types/provider-api';

const HOUR = 60 * 60 * 1000;

/** Administration routes (the route dropdown's fallback when a med carries no route[] of its own). */
export function useMedicationRoutes() {
  return useQuery<ProviderCode[]>({
    queryKey: ['medication-routes'],
    queryFn: ({ signal }) => get<ProviderCode[]>('/api/Master/MedicationRoute', { signal }),
    staleTime: HOUR,
  });
}

/** Dose / dispense unit options (mg, tablet, ml…). */
export function useMedicationUnits() {
  return useQuery<string[]>({
    queryKey: ['medication-units'],
    queryFn: ({ signal }) => get<string[]>('/api/Master/MedicationUnitOfMeasurement', { signal }),
    staleTime: HOUR,
  });
}
